import React, { useRef } from 'react';
import Arrow from '@material-ui/icons/ArrowUpward';
import teleImg from '../assets/svg/Home SVGs/telegram.svg';
import masImg from '../assets/svg/Home SVGs/messenger.svg';
import { NavLink } from 'react-router-dom';
import YoutubeEmbed from './YoutubeEmbed';
function AboutSection() {
  const teleRef = useRef(null);
  const masRef = useRef(null);

  const copyTele = (e) => {
    teleRef.current.select();
    document.execCommand('copy');
    alert('تم النسخ');
  };
  const copyMas = (e) => {
    masRef.current.select();
    document.execCommand('copy');
    alert('تم النسخ');
  };
  return (
    <div className=' font-semibold text-lg  bg-img-1 '>
      <div className='w-full h-full bg-white sm:bg-transparent '>
        <div className=' flex flex-col content-center items-center'>
          <br />
          <h1 className='block text-center text-lg'>
            هل انت بحاجة الى المساعدة ؟ تواصل عن طريق البوت او عن طريق
            <span> </span>
            <NavLink to='/ask-for-help' className='n-green'>
              الموقع
            </NavLink>
          </h1>
          <div className='self-center my-8'>
            <a href='https://t.me/NabeelOfBot' target='_blanck'>
              <button className='blue-bg border text-white rounded-lg p-2 w-40 flex justify-around focus:outline-none mb-8'>
                <img className='mt-0' src={teleImg} alt='tele' />
                Telegram bot
              </button>
            </a>
          </div>
        </div>
        <h1 className='text-4xl lg:mb-8 text-center my-20 '>
          كيفية استخدام الموقع
        </h1>

        <div className='video-section my-20'>
          <YoutubeEmbed embedId='j3HPLqYYw3w' />
        </div>
        <div className='flex justify-center n-green'>
          <a href='#nav'>
            <Arrow
              alt='arrow'
              className='my-auto ml-1'
              style={{ fontSize: 40 }}
            />
          </a>
        </div>
      </div>
    </div>
  );
}
export default AboutSection;
